import { MainContainer } from '@/components/atoms'
import {
  CreateSubscriptionForm,
  Section,
  SubscriptionsTable,
} from '@/components/molecules'
import { useCancelSubscription } from '@/hooks'
import { useEffect, useState } from 'react'

export const ManageSubscriptions = ({ subscriptions, refetchSubs }) => {
  const [showCreateSubscription, setShowCreateSubscription] = useState(false)
  const { submit: submitCancelSub, isSuccess } = useCancelSubscription()

  const handleCreateSubscriptionShow = () => {
    setShowCreateSubscription(true)
  }

  useEffect(() => {
    if (isSuccess) {
      refetchSubs()
    }
  }, [isSuccess, refetchSubs])

  return (
    <MainContainer>
      <Section
        title="My Subscriptions"
        action={{
          action: handleCreateSubscriptionShow,
          text: 'Create Subscription',
        }}
        alignItems={'stretch'}
      >
        {showCreateSubscription && (
          <CreateSubscriptionForm
            refetchSubs={refetchSubs}
            maxW={400}
            p={4}
            border={'1px solid'}
            borderColor={'gray.200'}
            rounded={'md'}
            boxShadow={'base'}
          />
        )}

        <SubscriptionsTable
          subscriptions={subscriptions}
          submitCancelSub={submitCancelSub}
        />
      </Section>
    </MainContainer>
  )
}
